<template>
  <div class="detail">
    <div class="divl">
      <div class="allmulu">所有类目</div>
      <el-menu :default-active="currentNumber" class="el-menu-vertical-demo">
        <!-- <el-submenu index="1">
        <template slot="title">
         
          <span>导航一</span>
        </template>
    
          
          <el-menu-item index="1-1">选项1</el-menu-item>
          <el-menu-item index="1-2">选项2</el-menu-item>
      
        
      </el-submenu> -->
        <el-submenu
          v-for="item in dataList"
          :key="item.id"
          :index="item.number"
        >
          <template slot="title">
            <span>{{ item.classname }}</span>
          </template>
          <el-menu-item
            v-for="item1 in item.list"
            :key="item1.id"
            :index="item1.keyword"
            @click="getContent(item.classname, item1)"
            >{{ item1.title }}</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </div>
    <div class="divr">
      <div class="brand">
        {{ tname }} > <span style="color: #666">{{ content.title }}</span>
      </div>
      <div class="htmlDiv" v-html="content.content"></div>
    </div>
  </div>
</template>

<script>
import { help } from "../api/mian.js"

export default {
  data () {
    return {
      dataList: [{}, {}],
      content: '',
      tname: '',
      currentNumber: '',
      clickItem: {},

    }
  },
  created () {
    help().then(res => {
      this.dataList = res.data.data
    })
    this.clickItem = JSON.parse(this.$route.query.item)
    this.tname = this.$route.query.classname
    console.log(this.clickItem)
    this.currentNumber = this.clickItem.keyword
    this.getContent(this.tname, this.clickItem)

  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    getContent (tname, item) {
      console.log(item)
      this.tname = tname
      this.content = item
      console.log(this.content)
    }
  },
};
</script>

<style scoped>
.brand {
  padding: 0 20px;
  height: 60px;
  line-height: 60px;
  background-color: #eaeaea;
}

.detail >>> .el-submenu__title {
  font-size: 24px;
  background-color: #eaeaea;
}

.detail >>> .el-menu-item {
  font-size: 20px;
  border-bottom: #eaeaea 1px solid;
}

.allmulu {
  height: 60px;
  background-color: #6688ea;
  line-height: 60px;
  text-align: center;
  color: #ffffff;
}

.detail {
  font-size: 24px;
  padding: 30px;
  margin: 0 auto;
  display: flex;
  margin-bottom: 30px;
  width: 1790px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
}

.divl {
  width: 300px;
}

.divr {
  flex: 1;
  /* background-color: goldenrod; */
  /* padding: 20px; */
}

.htmlDiv {
  padding: 20px;
  font-size: 20px !important;
}

.htmlDiv >>> p {
  font-size: 20px !important;
}

.htmlDiv >>> p span {
  font-size: 20px !important;
}
</style>